import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { viewInternLeaveApplications } from "../../http";
import Loading from "../Loading";

const InternLeaveDetails = () => {
  const { id } = useParams();
  const { user } = useSelector((state) => state.authSlice);
  const [application, setApplication] = useState();
  const isLeader = user && (user.type === "leader" || user.type === "Leader");

  useEffect(() => {
    const fetchData = async () => {
      const obj = {
        _id: id,
      };
      const res = await viewInternLeaveApplications(obj);
      setApplication(res.data[0]);
    };
    fetchData();
  }, [id]);

  return application ? (
    <div className="main-content">
      <section className="section">
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h4>Application on {application?.appliedDate}</h4>
          </div>
        </div>

        <div className="col-md-9">
          <table className="table">
            <tbody>
              <tr>
                <th>Title</th>
                <td>{application?.title}</td>
              </tr>
              <tr>
                <th>Type</th>
                <td>{application?.type}</td>
              </tr>
              <tr>
                <th>Reason</th>
                <td>{application?.reason}</td>
              </tr>
              <tr>
                <th>Start Date</th>
                <td>
                  {new Date(application?.startDate)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                </td>
              </tr>
              <tr>
                <th>End Date</th>
                <td>
                  {new Date(application?.endDate)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                </td>
              </tr>
              <tr>
                <th>Applied Date</th>
                <td>
                  {new Date(application?.appliedDate)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                </td>
              </tr>
              <tr>
                <th>Period</th>
                <td>{application?.period}</td>
              </tr>

              {/* Hide Leader Response and Message for Leaders */}
              {!isLeader && (
                <>
                  <tr>
                    <th>Leader Response</th>
                    <td>{application?.leaderResponse}</td>
                  </tr>
                  <tr>
                    <th>Leader Message</th>
                    <td>{application?.leaderMessage}</td>
                  </tr>
                </>
              )}

              <tr>
                <th>Admin Response</th>
                <td
                  className={`${
                    application?.adminResponse?.toLowerCase() === "rejected"
                      ? "text-danger"
                      : application?.adminResponse?.toLowerCase() === "pending"
                      ? "text-warning"
                      : "text-success"
                  }`}>
                  {application?.adminResponse
                    ? application.adminResponse.charAt(0).toUpperCase() +
                      application.adminResponse.slice(1).toLowerCase()
                    : ""}
                </td>
              </tr>
              <tr>
                <th>Message</th>
                <td>{application?.adminMessage}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  ) : (
    <Loading />
  );
};

export default InternLeaveDetails;
